import { render, staticRenderFns } from "./calendar-event.vue?vue&type=template&id=591450ba&scoped=true&"
import script from "./calendar-event.vue?vue&type=script&lang=js&"
export * from "./calendar-event.vue?vue&type=script&lang=js&"
import style0 from "./calendar-event.vue?vue&type=style&index=0&id=591450ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591450ba",
  null
  
)

export default component.exports